// This file was automatically generated and should not be edited.
export const LIB_VERSION = "4.22.1";
//# sourceMappingURL=version.js.map